<template>
  <div class="table-wrapper cover-content project-list">
    <div class="boxList"  v-loading="loading">
      <Row>
        <Col :span="6">
          <div style="font-size: 28px; font-weight: 900">
            项目名称: {{ projectName }}
          </div>
        </Col>
        <Col :span="6">
          <Row>
            <Col :span="4" style="line-height: 42px"> 选择配置的接口: </Col>
            <Col :span="8" style="line-height: 42px">
              <Select
                v-model="pushModel"
                clearable
                placeholder="请选配置的接口"
                @on-change="changeSelect"
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in pushList"
                  :key="index"
                  >{{ item.systemName }}</Option
                >
              </Select>
            </Col>
          </Row>
        </Col>
        <!-- <Col :span="6">
          <Button :loading="InfoLoading" type="primary" @click="getWorkerInfo">关键岗位人员信息校准</Button>
        </Col> -->
      </Row>
      <Row class="row">
        <Col :span="4">
          <!-- @click="handleClick('addProject','项目信息')"  -->
          <Button
            type="primary"
            size="small"
            v-if="rowDataList.length > 0"
            @click="
              handleClick(
                'addProject',
                '项目信息',
                rowDataList[0].pushSuccess,
                rowDataList[0].pushing,
                rowDataList[0].pushFail
              )
            "
            >{{ rowDataList[0].methodName }}</Button
          >
        </Col>
        <Col :span="4" v-if="rowDataList.length > 0">
          <p>{{ rowDataList[0].message }}</p>
        </Col>
      </Row>
      <Row
        class="row"
        v-for="(item, index) in rowDataList.slice(1)"
        :key="index"
      >
        <Col :span="4">
          <Button
            type="primary"
            size="small"
            @click="
              handleClick(
                item.method,
                item.methodName,
                item.pushSuccess,
                item.pushFail,
                item.pushing
              )
            "
            >{{ item.methodName=='人员进出场信息'?'人员进退场信息':item.methodName }}</Button
          >
        </Col>
        <Col :span="4">
          <p>推送成功： {{ item.pushSuccess }}</p>
        </Col>
        <Col :span="4">
          <p>推送中： {{ item.pushing }}</p>
        </Col>
        <Col :span="4">
          <p>推送失败：{{ item.pushFail }}</p>
        </Col>
      </Row>
    </div>
    <!-- <Modal v-model="showModal" footer-hide width="800" title="关键岗位人员信息校准">
      <div>
        <div v-for="(item,index) in rowDataModal" :key="index">
           <div>{{item}}</div>
        </div>
      </div>
    </Modal> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      projectId: "",
      loading: true,
      rowDataList: [],
      projectName: "",
      pushList: [],
      pushModel: null,
      pushId: "",
      InfoLoading: false,
      showModal: false,
      rowDataModal: []
    };
  },
  created() {
    (this.projectId = this.$route.query.projectId),
      (this.projectName = this.$route.query.projectName);
    this.getPushDetails();
    this.getPushList();
  },
  methods: {
    // 获取系统列表
    getPushList() {
      this.axios({
        method: "get",
        url: "/push/pushSystemInfo",
      }).then((res) => {
        this.pushList = res.data.data;
      });
    },
    // 关键岗位人员信息校准
    // getWorkerInfo() {
    //   this.InfoLoading=true;
    //   this.axios({
    //     method: "get",
    //     url: "/push/adjustProjectKeyPositionWorkerInfo",
    //     params: {
    //       projectId: this.projectId,
    //       sysId: this.pushList[0].id,
    //     },
    //   }).then((res) => {
    //     if(res.data.success){
    //       this.showModal = true;
    //       this.rowDataModal = res.data.data.split(";");
    //     } else {
    //       this.$Message.warning({
    //         content: res.data.errorMsg,
    //       });
    //     }
    //     this.InfoLoading=false;
    //   }).catch( ()=> {
    //     this.InfoLoading=false;
    //   });
    // },
    getPushDetails() {
      this.loading = true;
      this.axios({
        method: "get",
        url: "/push/projectPushInfo",
        params: {
          projectId: this.projectId,
          systemId:this.pushModel
        },
      }).then((response) => {
        this.loading = false;
        if (response.data.success) {
          this.rowDataList = response.data.data;
        }
      });
    },
    //切换select
    changeSelect(val) {
      this.pushModel = val;
      this.getPushDetails()
    },
    handleClick(type, title, pushSuccess, pushFail, pushing) {
      this.$router.push({
        name: "dataPushFrom",
        query: {
          type: type,
          title: title=='人员进出场信息'?'人员进退场信息':title,
          projectId: this.projectId,
          pushSuccess: pushSuccess,
          pushFail: pushFail,
          pushing: pushing,
        },
      });
    },
  },
};
</script>
<style scoped>
.boxList {
  margin: 24px;
}
.boxList .row {
  margin-top: 20px;
}
.boxList >>> .ivu-col-span-6 {
  width: 50% !important;
}
</style>
